import { render } from "./SwiperImageList.vue?vue&type=template&id=f3b9e2f0&ts=true"
import script from "./SwiperImageList.vue?vue&type=script&lang=ts"
export * from "./SwiperImageList.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__